import { useCallback, useEffect, useRef, useState } from "react";
import BarcodeReport from "./BarcodeReport"
import fileIcon from '../../../../assets/images/File.svg';
import { CustomDateFilterComponent, CustomDropdownFilterComponent } from "../../BulkOrder/Home/HomeHelper";
import { useDispatch, useSelector } from "react-redux";
import { getRegionDropDown } from "Store/Organization/Region/RegionAction";
import { getMarketDropDown } from "Store/Organization/Market/MarketAction";
import { getCostCenterByMarket } from "Store/Organization/CostCenterByMarket/CostCenterByMarketAction";
import { getBarcodeReportAssetImages, getBarcodeReportCostCenterDropdown, getBarcodeReportExcelData, getBarcodeReportGridData, getBarcodeReportMarketDropdown, getBarcodeReportRegionDropdown, getBarcodeReportUserDropdown, setBarcodeReportExcelData, setBarcodeReportGridFilters } from "Store/Report/BarcodeReport/BarcodeReportAction";
import { useDebounce } from "client/CommonComponents/CustomDebounce/DebounceHook";
import userProfileSelectors from "../../../../../redux/UserProfile/selectors"
import { base64ToArrayBuffer, saveByteArray } from "utils";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { operations } from "redux/Navigation";


const BarcodeReportContainer = () => {
  const breadcrumlist = [
    { text: "Barcode Replacement", key: "f2" }, {}
  ];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dispatchHeaderNav = operations.dispatchHeaderNav(dispatch);
  const navDispatch = operations.dispatchNav(dispatch);

  const [regionDropDownList, setRegionDropDownList] = useState<any>([]);
  const [selectedRegion, setSelectedRegion] = useState<any>();
  const [filteredValues, setFilteredValues] = useState<any>({});

  const [marketDropDownList, setMarketDropDownList] = useState<any>([]);
  const [selectedMarket, setSelectedMarket] = useState<any>();

  const [costCenterDropdownList, setCostCenterDropdownList] = useState([]);
  const [selectedCostCenter, setSelectedCostCenter] = useState<any>();

  const [showGrid, setShowGrid] = useState(true);

  const [gridData, setGridData] = useState([])
  const [serverTotal, setServerTotal] = useState(0);
  const [paginationData, setPaginationData] = useState<any>({});
  const [pagesCount, setPagesCount] = useState<number>(0);
  const [sortData, setSortData] = useState<any>({});
  const [isClearFilterClicked, setIsClearFilterClicked] = useState<boolean>(false);

  const [showAssetImagePopup, setShowAssetImagePopup] = useState(false)

  /// useRef for filter dropdown list
  const userList: any = useRef([]);
  const regionList: any = useRef([]);
  const marketList: any = useRef([]);
  const costCenterList: any = useRef([]);

  /// useRef for selected filter values
  const userSelected: any = useRef([]);
  const regionSelected: any = useRef([]);
  const marketSelected: any = useRef([]);
  const costCenterSelected: any = useRef([]);

  /// useRef for text filter
  const assetNumberSelected: any = useRef([]);
  const barcodeNumberSelected: any = useRef([]);
  const previousBarcodeNumberSelected: any = useRef([]);
  const updatedDate = useRef<any>(null);

  const {
    regionDropDown,
    marketDropDown,
    costCenterByMarketDropDownList,
    barcodeReportUserDropdown,
    barcodeReportRegionDropdown,
    barcodeReportMarketDropdown,
    barcodeReportCostCenterDropdown,
    barcodeReportExcelData,
    barcodeReportGridData,
    barcodeReportGridFilters,
    userDetails,
  }: any = useSelector((state: any) => ({
    regionDropDown: state?.RegionDropDownReducer?.regionDropDown,
    marketDropDown: state?.MarketDropDownReducer?.marketDropDown,
    costCenterByMarketDropDownList: state.CostCenterByMarketReducers.costCenterByMarket,
    barcodeReportUserDropdown: state.BarcodeReportReducer.barcodeReportUserDropdown,
    barcodeReportRegionDropdown: state.BarcodeReportReducer.barcodeReportRegionDropdown,
    barcodeReportMarketDropdown: state.BarcodeReportReducer.barcodeReportMarketDropdown,
    barcodeReportCostCenterDropdown: state.BarcodeReportReducer.barcodeReportCostCenterDropdown,
    barcodeReportExcelData: state.BarcodeReportReducer.barcodeReportExcelData,
    barcodeReportGridData: state.BarcodeReportReducer.barcodeReportGridData,
    barcodeReportGridFilters: state.BarcodeReportReducer.barcodeReportGridFilters,
    userDetails: userProfileSelectors.getUserDetails(state),
  }));

  useEffect(() => {
    !regionDropDown?.length && dispatch(getRegionDropDown());
    !barcodeReportUserDropdown?.length && dispatch(getBarcodeReportUserDropdown());
    !barcodeReportRegionDropdown?.length && dispatch(getBarcodeReportRegionDropdown());
    !barcodeReportMarketDropdown?.length && dispatch(getBarcodeReportMarketDropdown());
    !barcodeReportCostCenterDropdown?.length && dispatch(getBarcodeReportCostCenterDropdown());
    navDispatch("Reports");
    dispatchHeaderNav("Reports");
  }, [])

  useEffect(() => {
    if (barcodeReportExcelData != null && barcodeReportExcelData?.status == "success" && barcodeReportExcelData?.response?.length) {
      const bytes = base64ToArrayBuffer(barcodeReportExcelData?.response);
      saveByteArray("BarcodeReport", bytes, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      dispatch(setBarcodeReportExcelData([]));
    }
  }, [barcodeReportExcelData])

  const clearFilterValues = {
    assetNumber: '',
    currentBarcode: '',
    previousBarcode: '',
    modifiedUser: '',
    region: '',
    market: '',
    costCenter: '',
    modified: null,
    costCenterSearch: '',
    regionSearch: '',
    marketSearch: ''
  }

  const alreadyHasGridFilterValues = useCallback(() => {
    let isAlreadyHasValues = true
    let GridFilterValueTemp: any = barcodeReportGridFilters;

    Object.keys(clearFilterValues)?.forEach((filterItem?: any) => {
      Object.keys(GridFilterValueTemp ?? {})?.forEach((gridItem?: any) => {
        if (filterItem == gridItem) {
          let val = gridItem
          if (GridFilterValueTemp[val] != "" && GridFilterValueTemp[val] != null && GridFilterValueTemp[val] != undefined && val != "globalSearchField" && val != "loggedInMail") {
            isAlreadyHasValues = false
          }
        }
      })
    });
    return isAlreadyHasValues
  }, [barcodeReportGridFilters, selectedRegion, selectedMarket, selectedCostCenter, isClearFilterClicked])

  const alreadyHasValues = () => {
    let isAlreadyHasValues = false
    Object.keys(clearFilterValues)?.forEach((filterItem?: any) => {
      Object.keys(barcodeReportGridFilters ?? {})?.forEach((gridItem?: any) => {
        if (filterItem == gridItem) {
          isAlreadyHasValues = true
        }
      })
    })
    return isAlreadyHasValues
  }

  const setSavedFilterValues = () => {
    if (userDetails?.hasOwnProperty('userGridFilters') && regionDropDown?.length > 0) {
      if (!alreadyHasValues()) {
        userDetails?.userGridFilters?.map((item: any) => {
          if (item?.pageName === 'Barcode Reporting') {
            item?.gridFilter?.map((filter: any) => {
              if (filter?.gridName === 'Dashboard') {
                let filterObj: any = []
                filter?.filterValues?.map((filterItem: any) => {
                  switch (filterItem?.filterName) {
                    case 'assetNumber':
                      assetNumberSelected.current = filterItem?.filterValue;
                      filterObj[filterItem?.filterName] = filterItem?.filterValue;
                      break;
                    case 'currentBarcode':
                      barcodeNumberSelected.current = filterItem?.filterValue;
                      filterObj[filterItem?.filterName] = filterItem?.filterValue;
                      break;
                    case 'previousBarcode':
                      previousBarcodeNumberSelected.current = filterItem?.filterValue;
                      filterObj[filterItem?.filterName] = filterItem?.filterValue;
                      break;
                    case 'user':
                      const findUserValue = barcodeReportUserDropdown?.find((item: any) => item.value == filterItem?.filterValue)
                      userSelected.current = findUserValue?.text
                      filterObj['modifiedUser'] = findUserValue?.text
                      break;
                    case 'regionId':
                      const findRegionValue = barcodeReportRegionDropdown?.find((item: any) => item.value == filterItem?.filterValue)
                      regionSelected.current = findRegionValue?.text
                      filterObj['region'] = findRegionValue?.text
                      break;
                    case 'marketId':
                      const findMarketValue = barcodeReportMarketDropdown?.find((item: any) => item.value == filterItem?.filterValue)
                      marketSelected.current = findMarketValue?.text
                      filterObj['market'] = findMarketValue?.text
                      break;
                    case 'costCenterId':
                      const findCostCenterValue = barcodeReportCostCenterDropdown?.find((item: any) => item.value == filterItem?.filterValue)
                      costCenterSelected.current = findCostCenterValue?.text
                      filterObj['costCenter'] = findCostCenterValue?.text
                      break;
                    case 'modified':
                      updatedDate.current = filterItem?.filterValue != "" ? new Date(filterItem?.filterValue) : null;
                      filterObj[filterItem?.filterName] = filterItem?.filterValue != "" ? moment(new Date(filterItem?.filterValue)).format('MM/DD/YYYY') : null;
                      break;
                    case 'regionSearch':
                      const findRegionSearchValue = regionDropDown?.find((item: any) => item.value == filterItem?.filterValue)
                      findRegionSearchValue?.value && setSelectedRegion({ ...findRegionSearchValue, label: findRegionSearchValue?.text, key: findRegionSearchValue?.value });
                      filterItem?.filterValue && dispatch(getMarketDropDown(filterItem?.filterValue));
                      if (findRegionSearchValue?.value) filterObj[filterItem?.filterName] = findRegionSearchValue;
                      break;
                    case 'marketSearch':
                      setFilteredValues((prev: any) => ({ ...prev, marketSearch: filterItem?.filterValue }));
                      filterItem?.filterValue && dispatch(getCostCenterByMarket({ marketId: filterItem?.filterValue }, true));
                      break;
                    case 'costCenterSearch':
                      setFilteredValues((prev: any) => ({ ...prev, costCenterSearch: filterItem?.filterValue }));
                      break;
                    default:
                      filterObj[filterItem?.filterName] = filterItem?.filterValue;
                  }
                })
                dispatch(setBarcodeReportGridFilters(filterObj));
              }
            })
          }
        })
      } else {
        assetNumberSelected.current = barcodeReportGridFilters?.assetNumber ?? ''
        previousBarcodeNumberSelected.current = barcodeReportGridFilters?.previousBarcode ?? ''
        barcodeNumberSelected.current = barcodeReportGridFilters?.currentBarcode ?? ''
        updatedDate.current = barcodeReportGridFilters?.modified ? new Date(barcodeReportGridFilters?.modified) : null;
        userSelected.current = barcodeReportGridFilters?.modifiedUser
        regionSelected.current = barcodeReportGridFilters?.region
        marketSelected.current = barcodeReportGridFilters?.market
        costCenterSelected.current = barcodeReportGridFilters?.costCenter

        if (barcodeReportGridFilters?.regionSearch) {
          setSelectedRegion(barcodeReportGridFilters?.regionSearch)
          dispatch(getMarketDropDown(barcodeReportGridFilters?.regionSearch?.key))
        }
        if (barcodeReportGridFilters?.marketSearch) {
          dispatch(getCostCenterByMarket({ marketId: barcodeReportGridFilters?.marketSearch?.key }, true))
          setSelectedMarket(barcodeReportGridFilters?.marketSearch)
        }
        if (barcodeReportGridFilters?.costCenterSearch) {
          setSelectedCostCenter(barcodeReportGridFilters?.costCenterSearch)
        }
      }
    }
  }
  useEffect(() => {
    if (userDetails?.userGridFilters?.length && barcodeReportUserDropdown?.length && barcodeReportRegionDropdown?.length && barcodeReportMarketDropdown?.length && barcodeReportCostCenterDropdown?.length) {
      setSavedFilterValues();
      setShowGrid(false);
      setTimeout(() => {
        setShowGrid(true);
      }, 500);
    }
  }, [userDetails, barcodeReportUserDropdown, barcodeReportRegionDropdown, barcodeReportMarketDropdown, barcodeReportCostCenterDropdown, regionDropDown]);

  useEffect(() => {
    if (regionDropDown?.length) {
      const regionDropDownTemp = regionDropDown?.map((item: any) =>
        ({ label: item.text, key: item.value, ...item })
      );
      setRegionDropDownList(regionDropDownTemp);
    }
  }, [regionDropDown])

  useEffect(() => {
    if (marketDropDown?.length) {
      const marketDropDownTemp = marketDropDown?.map((item: any) =>
        ({ label: item.text, key: item.value, ...item })
      );
      setMarketDropDownList(marketDropDownTemp);
      if (filteredValues?.marketSearch) {
        const selectedMarketTemp = marketDropDown?.find((item: any) => item.value === filteredValues?.marketSearch);
        setSelectedMarket({ ...selectedMarketTemp, label: selectedMarketTemp?.text, key: selectedMarketTemp?.value });
        setFilteredValues({ ...filteredValues, marketSearch: null });
      }
    }
  }, [marketDropDown, filteredValues?.marketSearch])

  useEffect(() => {
    if (costCenterByMarketDropDownList?.length) {
      const costCenterDropdownListTemp = costCenterByMarketDropDownList?.map((item: any, _index: number) => ({ ...item, label: item?.text, key: item?.value }));
      setCostCenterDropdownList(costCenterDropdownListTemp);
      if (filteredValues?.costCenterSearch) {
        const selectedCostCenterTemp = costCenterByMarketDropDownList?.find((item: any) => item.value === filteredValues?.costCenterSearch);
        setSelectedCostCenter({ ...selectedCostCenterTemp, label: selectedCostCenterTemp?.text, key: selectedCostCenterTemp?.value });
        setFilteredValues({ ...filteredValues, costCenterSearch: null });
        fetchGridData("grid");
      }
    }
  }, [costCenterByMarketDropDownList, filteredValues?.costCenterSearch])

  useEffect(() => {
    if (barcodeReportUserDropdown?.length) {
      userList.current = barcodeReportUserDropdown?.map((item: any) => ({ label: item?.text, value: item?.value }));
    }
  }, [barcodeReportUserDropdown])

  useEffect(() => {
    if (barcodeReportRegionDropdown?.length) {
      regionList.current = barcodeReportRegionDropdown?.map((item: any) => ({ label: item?.text, value: item?.value }));
    }
  }, [barcodeReportRegionDropdown])

  useEffect(() => {
    if (barcodeReportMarketDropdown?.length) {
      marketList.current = barcodeReportMarketDropdown?.map((item: any) => ({ label: item?.text, value: item?.value }));
    }
  }, [barcodeReportMarketDropdown])

  useEffect(() => {
    if (barcodeReportCostCenterDropdown?.length) {
      costCenterList.current = barcodeReportCostCenterDropdown?.map((item: any) => ({ label: item?.text, value: item?.value }));
    }
  }, [barcodeReportCostCenterDropdown])

  useEffect(() => {
    assetNumberSelected.current = barcodeReportGridFilters?.assetNumber ?? ''
  }, [barcodeReportGridFilters?.assetNumber])

  useEffect(() => {
    barcodeNumberSelected.current = barcodeReportGridFilters?.currentBarcode ?? ''
  }, [barcodeReportGridFilters?.currentBarcode])

  useEffect(() => {
    previousBarcodeNumberSelected.current = barcodeReportGridFilters?.previousBarcode ?? ''
  }, [barcodeReportGridFilters?.previousBarcode])

  useEffect(() => {
    if (barcodeReportGridData?.data?.length) {
      setIsClearFilterClicked(false)
      setGridData(barcodeReportGridData?.data);
      setServerTotal(barcodeReportGridData?.totalRecords);
    } else {
      setGridData([]);
      setServerTotal(barcodeReportGridData?.totalRecords);
    }
  }, [barcodeReportGridData])

  const debounceObject = [
    paginationData, assetNumberSelected, barcodeNumberSelected, previousBarcodeNumberSelected, userSelected, regionSelected,
    marketSelected, costCenterSelected, updatedDate, sortData, isClearFilterClicked
  ]

  const globalDebounce = useDebounce(debounceObject, 500)

  useEffect(() => {
    fetchGridData("grid")
  }, [globalDebounce])

  useEffect(() => {
    if (serverTotal && paginationData?.pageSize) {
      let pageSize = paginationData?.pageSize
      let tempPageCount = serverTotal > pageSize ? Math.ceil(serverTotal / pageSize - 1) : 0
      setPagesCount(tempPageCount)
    }
  }, [serverTotal, paginationData?.pageSize])

  const fetchAction = useCallback((fetchData: any) => {
    if (fetchData.action && fetchData.action === "paging") {
      let paginationData = fetchData.data
      setPaginationData(paginationData)
      dispatch(setBarcodeReportGridFilters(paginationData));
    }
    if (fetchData.action && fetchData.action === "sorting") {
      const data = fetchData.data[0];
      setSortData(data);
      dispatch(setBarcodeReportGridFilters({ sortData: data }));
    }
  }, [])

  const fetchGridData = (callType?: any) => {
    let payload: any = {
      "pageNumber": paginationData?.pageIndex != undefined ? paginationData?.pageIndex + 1 : undefined,
      "pageSize": paginationData?.pageSize,
      "columnFilters": getFilteredValues(),
      "gridFilterName": '',
      "loggedInMail": userDetails?.emailId
    }
    if (selectedRegion?.label) {
      payload.regionId = selectedRegion?.key ? selectedRegion?.key : '';
    }
    if (selectedMarket?.label) {
      payload.marketId = selectedMarket?.key ? selectedMarket?.key : '';
    }
    if (selectedCostCenter?.label) {
      payload.costCenterId = selectedCostCenter?.key ? selectedCostCenter?.key : '';
    }

    if (sortData?.key != '') {
      payload.sortBy = sortData?.key;
      payload.sortOrder = sortData?.sortDirection;
    }

    if (payload.pageNumber && payload.pageSize) {
      if (callType === "excel") {
        dispatch(getBarcodeReportExcelData(payload));
      } else if (callType === "grid") {
        dispatch(getBarcodeReportGridData(payload))
      }
    }
  }

  const getFilteredValues = () => {
    let filteredValues: any = [];
    if (assetNumberSelected.current != "" && assetNumberSelected.current != undefined) {
      filteredValues.push({ 'field': 'assetNumber', 'value': assetNumberSelected.current })
    }
    if (barcodeNumberSelected.current != "" && barcodeNumberSelected.current != undefined) {
      filteredValues.push({ 'field': 'currentBarcode', 'value': barcodeNumberSelected.current })
    }
    if (previousBarcodeNumberSelected.current != "" && previousBarcodeNumberSelected.current != undefined) {
      filteredValues.push({ 'field': 'previousBarcode', 'value': previousBarcodeNumberSelected.current })
    }
    if (userSelected.current != "" && userSelected.current != undefined) {
      const findValue = barcodeReportUserDropdown?.find((item: any) => item.text === userSelected.current)
      filteredValues.push({ 'field': 'user', 'value': findValue?.value })
    }
    if (regionSelected.current != "" && regionSelected.current != undefined) {
      const findValue = barcodeReportRegionDropdown?.find((item: any) => item.text === regionSelected.current)
      filteredValues.push({ 'field': 'regionId', 'value': findValue?.value })
    }
    if (marketSelected.current != "" && marketSelected.current != undefined) {
      const findValue = barcodeReportMarketDropdown?.find((item: any) => item.text === marketSelected.current)
      filteredValues.push({ 'field': 'marketId', 'value': findValue?.value })
    }
    if (costCenterSelected.current != "" && costCenterSelected.current != undefined) {
      const findValue = barcodeReportCostCenterDropdown?.find((item: any) => item.text === costCenterSelected.current)
      filteredValues.push({ 'field': 'costCenterId', 'value': findValue?.value })
    }
    if (updatedDate.current != null) {
      filteredValues.push({ 'field': 'modified', 'value': moment(new Date(updatedDate.current)).format('YYYY-MM-DD') })
    }
    return filteredValues;
  }

  const setFilters = (value: any) => {
    if (JSON.stringify(value) !== '{}') {
      dispatch(setBarcodeReportGridFilters(value));
    }
  }

  const handleSearchGrid = () => {
    dispatch(setBarcodeReportGridFilters({ ...barcodeReportGridFilters, regionSearch: selectedRegion, marketSearch: selectedMarket, costCenterSearch: selectedCostCenter }))
    fetchGridData("grid")
  }

  const handleFilterClear = () => {
    setIsClearFilterClicked(true)
    setSelectedCostCenter('')
    setSelectedMarket('')
    setSelectedRegion('')
    setCostCenterDropdownList([])
    setMarketDropDownList([])
    dispatch(setBarcodeReportGridFilters({
      paginationData: { pageIndex: 0, pageSize: 10 },
      assetNumber: '',
      currentBarcode: '',
      previousBarcode: '',
      modifiedUser: '',
      region: '',
      market: '',
      costCenter: '',
      modified: null,
      sortData: {},
      regionSearch: '',
      marketSearch: '',
      costCenterSearch: '',
    }));
    userSelected.current = [];
    regionSelected.current = [];
    marketSelected.current = [];
    costCenterSelected.current = [];
    updatedDate.current = null;
    setShowGrid(false);
    setTimeout(() => {
      setShowGrid(true);
    })
  }

  const handleClearFilter = (filterName: string) => {
    switch (filterName) {
      case "modifiedUser":
        dispatch(setBarcodeReportGridFilters({ modifiedUser: '' }));
        break;
      case "region":
        dispatch(setBarcodeReportGridFilters({ region: '' }));
        break;
      case "market":
        dispatch(setBarcodeReportGridFilters({ market: '' }));
        break;
      case "costCenter":
        dispatch(setBarcodeReportGridFilters({ costCenter: '' }));
        break;
      case "modified":
        dispatch(setBarcodeReportGridFilters({ modified: null }));
        break;
      default:
        break;
    }
  }

  const barcodeColumns = [
    {
      key: "assetNumber",
      title: "Asset ID",
      width: 120,
      Cell: (row: any) => {
        return (
          <a href="/" onClick={(e: any) => {
            onOrderIdClicked(e, row);
          }} className="order-link-id">
            {row.rowData.assetNumber}
          </a>
        );
      },
      filterRowValue: barcodeReportGridFilters?.assetNumber ?? ''
    },
    {
      key: "currentBarcode",
      title: "Barcode #",
      width: 120,
      filterRowValue: barcodeReportGridFilters?.currentBarcode ?? ''
    },
    {
      key: "previousBarcode",
      title: "Previous Barcode #",
      width: 120,
      filterRowValue: barcodeReportGridFilters?.previousBarcode ?? ''
    },
    {
      key: "modifiedUser",
      title: "User",
      width: 120,
      FilterCell: (filterProps: any) => {
        return <CustomDropdownFilterComponent {...filterProps} options={userList?.current} setDropdown={userSelected} handleClearFilter={handleClearFilter} />
      }
    },
    {
      key: "region",
      title: "Region",
      width: 120,
      FilterCell: (filterProps: any) => {
        return <CustomDropdownFilterComponent {...filterProps} options={regionList?.current} setDropdown={regionSelected} handleClearFilter={handleClearFilter} />
      }
    },
    {
      key: "market",
      title: "Market",
      width: 120,
      FilterCell: (filterProps: any) => {
        return <CustomDropdownFilterComponent {...filterProps} options={marketList?.current} setDropdown={marketSelected} handleClearFilter={handleClearFilter} />
      }
    },
    {
      key: "costCenter",
      title: "Cost Center",
      width: 120,
      FilterCell: (filterProps: any) => {
        return <CustomDropdownFilterComponent {...filterProps} options={costCenterList?.current} setDropdown={costCenterSelected} handleClearFilter={handleClearFilter} />
      }
    },
    {
      key: "modified",
      title: "Date/Time Updated",
      // Cell: (row: any) => {
      //   return (
      //     <p className="dateSubmitted">
      //       {row.rowData.modified
      //         ? moment(row.rowData.modified).format("MM/DD/YYYY")
      //         : ""}
      //     </p>
      //   );
      // },
      FilterCell: (props: any) => (<CustomDateFilterComponent {...props} setDate={updatedDate}  handleClearFilter={handleClearFilter}/>),
      width: 200,
    },
    {
      key: "assetImage",
      title: "Asset Image",
      width: 120,
      Cell: (row: any) => {
        return (
          <span
            className="file-icon-span"
            onClick={() => { setShowAssetImagePopup(true); dispatch(getBarcodeReportAssetImages(row.rowData.assetBarcodeId)) }}
          ><img src={fileIcon} alt="File Icon" /></span>
        )
      }
    },
  ];

  const handleChange = (value: any, name: string) => {
    switch (name) {
      case "region":
        setSelectedRegion(value);
        setSelectedMarket('')
        setSelectedCostCenter('')
        dispatch(getMarketDropDown(value?.key))
        break;
      case "market":
        setSelectedMarket(value);
        setSelectedCostCenter('')
        dispatch(getCostCenterByMarket({ marketId: value?.key }, true))
        break;
      case "costCenter":
        setSelectedCostCenter(value);
        break;
      default:
        break;
    }
  }

  const onClickExport = (e?: any) => {
    e.preventDefault();
    fetchGridData("excel")
  }

  const onOrderIdClicked = (e: any, row: any) => {
    e.preventDefault();
    navigate('/ordermanagement/activeasset/activeassetdashboard/' + row.rowData.assetNumber + '/barcodereport');
  }

  return (
    <BarcodeReport
      breadcrumlist={breadcrumlist}
      barcodeColumns={barcodeColumns}
      showAssetImagePopup={showAssetImagePopup}
      setShowAssetImagePopup={setShowAssetImagePopup}
      regionDropDownList={regionDropDownList}
      selectedRegion={selectedRegion}
      handleChange={handleChange}
      marketDropDownList={marketDropDownList}
      selectedMarket={selectedMarket}
      costCenterDropdownList={costCenterDropdownList}
      selectedCostCenter={selectedCostCenter}
      fetchAction={fetchAction}
      serverTotal={serverTotal}
      pagesCount={pagesCount}
      barcodeReportGridData={gridData}
      setFilters={setFilters}
      handleSearchGrid={handleSearchGrid}
      handleFilterClear={handleFilterClear}
      showGrid={showGrid}
      onClickExport={onClickExport}
      alreadyHasGridFilterValues={alreadyHasGridFilterValues}
    />
  )
}

export default BarcodeReportContainer